/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Alert level based on risk profile thresholds
 */
export enum AlertLevel {

    Normal = 'normal',

    Warning = 'warning',

    Danger = 'danger',

    Critical = 'critical',

    Breached = 'breached'
}
